import { apiClient } from '@/lib/apiClient'

export type ChatTurn = {
  role: 'user' | 'assistant'
  content: string
}

export const tutorApi = {
  async getHistory(slug: string): Promise<ChatTurn[]> {
    const { data } = await apiClient.get<ChatTurn[]>(`/api/v1/tutor/problems/${slug}/chat`)
    return data
  },
}
